import { gql } from '@apollo/client';
import { DealFragment } from '../fragments/DealFragment';
/**
 * Public API: remove the promo code of a store cart.
 * @const RemovePromoCodeMutation
 * @since 1.0.0
 */
export const RemovePromoCodeMutation = gql `
  mutation RemovePromoCodeMutation($input: RemovePromoCodeInput!) {
    removePromoCode(input: $input) {
      ...DealFragment
    }
  }

  ${DealFragment}
`;
